export default __webpack_public_path__ + "static/agency_khu-6b01fa1a7017dac29615d3c088c89bd2.jpg";